import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GroupsService } from '../../../groups/groups.service';
import { TodosService } from '../todos.service';

@Component({
  selector: 'app-todos-config',
  templateUrl: './todos-config.component.html',
  styleUrls: ['./todos-config.component.scss'],
  standalone: false,
})
export class TodosConfigComponent implements OnInit, OnDestroy {
  selectedGroup = 'None';
  todoForm;
  groupList = [];
  translateSub;
  i18n = {};
  i18nList = ['Global.None'];

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private groupService: GroupsService,
    private todosService: TodosService
  ) {
    this.translateSub = this.translate.onLangChange.subscribe((res) => {
      this.getGroupNames();
      this.translateNames();
    });

    this.todoForm = this.fb.group({
      startDate: [moment().add(-1, 'weeks').format(), [Validators.required]],
      endDate: [moment().add(1, 'weeks').format(), [Validators.required]],
    });
  }

  ngOnInit() {
    this.getUserGroups();
    this.getTodos();
  }

  ngOnDestroy(): void {
    this.translateSub.unsubscribe();
  }

  translateNames() {
    this.translate.get(this.i18nList).subscribe((i18n) => {
      this.i18n = i18n;
      if (this.groupList.length > 1) {
        const index = this.groupList.findIndex((e) => e._id == 'None');
        if (index != -1) {
          this.groupList[index].name = this.i18n['Global.None'];
        }
      }
    });
  }

  getGroupNames() {
    this.groupList = this.groupList.map((group) => {
      if (group.__name) {
        group.name = group.__name.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      return group;
    });
  }

  public getUserGroups() {
    this.groupService.getUserGroups().subscribe((res) => {
      const first = { _id: 'None', name: 'Aucun' };
      this.groupList = [first];
      this.groupList = this.groupList.concat(res || []);
      this.getGroupNames();
      this.translateNames();
    });
  }

  groupSelected() {
    this.todosService.passTodoConfigData({
      event: 'selected-group',
      data: this.selectedGroup,
    });
  }
  getTodos() {
    this.todosService.passTodoConfigData({
      event: 'load-todos',
      data: {
        startDate: this.todoForm.value.startDate,
        endDate: this.todoForm.value.endDate,
      },
    });
  }
  addEvent() {
    this.todosService.passTodoConfigData({ event: 'add-todo' });
  }
}
